
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Punetomumbaiairportcab() {



    const cardData =
    {
        keyword: 'Pune to Mumbai Airport Cab',
        heading: 'Skyline Cabs: Pune to Mumbai Airport Cab',
        headingDescription: 'Skyline Cabs provides dependable and comfortable Pune to Mumbai Airport Cab services. Whether you’re catching a flight or returning home, our punctual pickups, skilled drivers, and clean, well-equipped vehicles ensure a stress-free airport transfer experience. With 24/7 availability and competitive pricing, Skyline Cabs makes your Pune to Mumbai Airport journey smooth, safe, and hassle-free.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

       "topPlaces": [
    {
        "title": "Gateway of India",
        "description": "An iconic landmark, the Gateway of India is a must-visit destination in Mumbai. Overlooking the Arabian Sea, this grand arch was built in 1924 to commemorate the visit of King George V and Queen Mary to India. It serves as a historic reminder of the colonial era and is a popular spot for photography, ferry rides to Elephanta Caves, and enjoying the sea breeze. The surrounding area is bustling with street vendors, tourists, and local performers, adding to the vibrant charm of the place."
    },
    {
        "title": "Marine Drive",
        "description": "Known as the Queen’s Necklace, Marine Drive is a 3.6 km long boulevard along the coast of South Mumbai. The stretch is lined with palm trees and offers stunning views of the Arabian Sea, making it an ideal spot for evening strolls, jogging, or simply relaxing by the sea. At night, the streetlights along the curved road resemble a string of pearls, creating a breathtaking visual effect. Marine Drive is also home to some of Mumbai’s finest restaurants, cafes, and luxury hotels, making it a favorite hangout for locals and tourists alike."
    },
    {
        "title": "Elephanta Caves",
        "description": "A UNESCO World Heritage Site, the Elephanta Caves are a group of rock-cut temples located on Elephanta Island, approximately 11 km from Mumbai. These caves date back to the 5th-7th century AD and are primarily dedicated to Lord Shiva. The most famous attraction here is the massive three-headed sculpture of Trimurti, symbolizing the three aspects of Shiva: Creator, Preserver, and Destroyer. The journey to the caves involves a scenic ferry ride from the Gateway of India, making it an adventure-filled and culturally enriching experience."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
        "description": "A magnificent railway station and UNESCO-listed site, CSMT is one of the finest examples of Victorian Gothic Revival architecture in India. Built in 1887 during British rule, this historic structure features a blend of Indian and European design elements, including domes, turrets, stained-glass windows, and intricate carvings. It serves as the headquarters of the Central Railway and is one of the busiest railway stations in India. The illuminated station at night is a sight to behold, attracting architecture and history enthusiasts."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "One of Mumbai's most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily. Built in 1801, the temple is known for its beautiful idol of Ganesha, carved from a single black stone with an elephant trunk tilted to the right. Celebrities, politicians, and common devotees visit the temple to seek blessings. Tuesdays witness a massive crowd of worshippers, as the day is considered auspicious for Lord Ganesha. The temple's serene ambiance offers a spiritual retreat amid Mumbai’s fast-paced life."
    },
    {
        "title": "Juhu Beach",
        "description": "Famous for its vibrant atmosphere, Juhu Beach is one of Mumbai’s most popular attractions. Stretching along the Arabian Sea, it is a hub for locals and tourists seeking relaxation, fun activities, and delicious street food. Visitors can enjoy horse rides, camel rides, and local delicacies like pav bhaji, vada pav, and bhel puri from the numerous food stalls lining the beach. Juhu Beach is also a popular spot for Bollywood celebrity sightings, as many film stars reside in the nearby luxurious localities."
    },
    {
        "title": "Colaba Causeway",
        "description": "A shopper’s paradise, Colaba Causeway is known for its lively street markets, trendy cafes, and colonial-era architecture. It offers a diverse range of goods, including jewelry, handicrafts, clothing, antiques, and souvenirs at bargain prices. The area is also home to some of Mumbai’s iconic eateries, such as Leopold Café and Café Mondegar, which are must-visit spots for food lovers. The fusion of street shopping, historical charm, and vibrant cafes makes Colaba Causeway an unmissable attraction in Mumbai."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and dargah situated on an islet in the Arabian Sea, Haji Ali Dargah is one of Mumbai’s most significant religious landmarks. Built in the 15th century, it houses the tomb of the Muslim saint Pir Haji Ali Shah Bukhari. The dargah is accessible via a narrow walkway during low tide, offering a unique experience as you walk toward this architectural marvel. It attracts visitors from all faiths, offering a peaceful retreat with mesmerizing views of the sea and skyline."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge that connects Bandra to Worli, significantly reducing travel time between the suburbs and South Mumbai. Spanning 5.6 km, it offers breathtaking views of the Mumbai skyline, especially at sunset and night when the bridge is beautifully illuminated. It is a symbol of Mumbai’s modern infrastructure and development, making it a favorite spot for photographers and travelers."
    },
    {
        "title": "Film City",
        "description": "Get a glimpse into Bollywood at Mumbai's famous Film City, officially known as Dadasaheb Phalke Chitranagari. Spread across 520 acres, it features multiple sets, including replicas of villages, urban streets, temples, and even forests, making it a key location for Bollywood films, TV shows, and commercials. Visitors can take guided tours to witness live shoots, explore film sets, and learn about the behind-the-scenes magic of India’s entertainment industry. For movie buffs, this is a dream destination."
    }
],


"services": [
    {
      "name": "Pune to Mumbai Airport Cab",
      "description": "Traveling from Pune to Mumbai Airport? Skyline Cabs offers fast, reliable, and comfortable airport transfers. Our fleet includes a range of vehicles to suit your needs, from compact cars to spacious SUVs, ensuring you travel in comfort. Whether you're flying for business or leisure, we guarantee a smooth ride with professional drivers who know the best routes."
    },
    {
      "name": "Pune to Mumbai Airport Cab Fare",
      "description": "Skyline Cabs provides affordable and transparent pricing for your Pune to Mumbai airport journey. No hidden charges, just clear and competitive rates for a premium travel experience. Get in touch to know the fare based on your specific travel details."
    },
    {
      "name": "Pune to Mumbai Airport",
      "description": "Need a convenient and hassle-free ride from Pune to Mumbai Airport? Skyline Cabs ensures a comfortable and timely journey, offering a variety of vehicles to suit your preferences. Our professional drivers ensure that you reach the airport on time, no matter the terminal."
    },
    {
      "name": "Pune to Mumbai Taxi Service",
      "description": "Skyline Cabs offers top-notch taxi services from Pune to Mumbai, ideal for business trips, leisure travel, or even airport transfers. Our vehicles are well-maintained and equipped with modern amenities, ensuring a comfortable journey. Trust our professional drivers to take you to your destination safely and on time."
    },
    {
      "name": "Pune to Mumbai Airport Cab Price",
      "description": "Skyline Cabs offers competitive and transparent pricing for your Pune to Mumbai airport journey. Whether you're heading to Terminal 1, 2, or 3, we provide fair pricing with no surprises. Book in advance for the best deals, and travel with peace of mind knowing you’re getting great value for your money."
    },
    {
      "name": "Pune Mumbai Airport Car Hire",
      "description": "Hire a car from Skyline Cabs for your Pune to Mumbai Airport trip and enjoy the flexibility of a personalized ride. Choose from a variety of cars including luxury vehicles for corporate or special events, or family-friendly options for a relaxed journey. Our professional drivers ensure a timely and comfortable ride."
    },
    {
      "name": "Pune to Mumbai Airport Cab Booking",
      "description": "Booking your Pune to Mumbai airport cab with Skyline Cabs is easy and hassle-free. You can book your ride online or via phone, and we offer a range of vehicle options to match your needs. Whether it’s a one-way trip or a round-trip service, you can count on us for reliable and timely transfers."
    },
    {
      "name": "Pune to Mumbai Airport Taxi Fare",
      "description": "Skyline Cabs offers clear and upfront pricing for taxi services between Pune and Mumbai Airport. We ensure you get a fair quote, with no hidden charges. Our aim is to make your journey as affordable and comfortable as possible while ensuring punctuality."
    },
    {
      "name": "Pune to Mumbai Airport Drop",
      "description": "Need a reliable drop-off service to Mumbai Airport from Pune? Skyline Cabs offers dependable drop-off services to all terminals, ensuring you arrive on time for your flight. With our convenient booking options, your journey will be smooth and stress-free, allowing you to focus on your travel rather than the logistics."
    },
    {
      "name": "Mumbai to Pune Innova Crysta Cab Booking",
      "description": "For a luxurious and comfortable ride from Mumbai to Pune, book an Innova Crysta with Skyline Cabs. This vehicle is perfect for those who want extra space, comfort, and style. Whether it’s a corporate trip or a family outing, the Innova Crysta provides an elegant and comfortable experience."
    },
    {
      "name": "Pune to Mumbai Cab Round Trip",
      "description": "Looking for a round-trip service between Pune and Mumbai? Skyline Cabs offers flexible round-trip options, ideal for those needing to return after a day of meetings or sightseeing. Enjoy the convenience of a single booking, and let us handle your transport needs throughout the day."
    },
    {
      "name": "Pune to Mumbai Ertiga Cab",
      "description": "If you're traveling with family or a small group, the Ertiga is an excellent choice for your Pune to Mumbai journey. Skyline Cabs offers this spacious vehicle with comfort, air-conditioning, and a smooth ride to ensure a pleasant journey for all passengers."
    },
    {
      "name": "Pune to Mumbai Innova Cab",
      "description": "Travel in comfort and style with the Innova cab from Skyline Cabs. Whether it's a business trip or a family vacation, the Innova offers ample space and a smooth ride for your Pune to Mumbai journey. Our drivers are experienced, ensuring you arrive relaxed and on time."
    },
    {
      "name": "Pune to Mumbai Airport Cab Service",
      "description": "Skyline Cabs offers a reliable and professional Pune to Mumbai Airport cab service. Our fleet of vehicles includes options for all types of travelers, from solo passengers to large groups. Whether you need a ride to Terminal 1, 2, or 3, we ensure a seamless travel experience."
    },
    {
      "name": "Pune to Mumbai Airport Cab Fare",
      "description": "Skyline Cabs provides affordable and competitive pricing for your Pune to Mumbai airport transfer. Get a clear estimate for your trip and enjoy a stress-free experience without worrying about hidden costs or additional fees."
    },
    {
      "name": "Pune to Mumbai Airport Taxi",
      "description": "Need a quick taxi ride from Pune to Mumbai Airport? Skyline Cabs offers fast and convenient taxi services, ensuring you reach your terminal in no time. Book in advance to secure the best rates and enjoy a comfortable ride."
    },
    {
      "name": "Pune to Mumbai Airport Innova",
      "description": "For a premium experience on your Pune to Mumbai Airport ride, opt for an Innova with Skyline Cabs. This vehicle offers maximum comfort and space, making it perfect for business travelers or families with a lot of luggage."
    },
    {
      "name": "Pune to Mumbai Airport Drop Cab",
      "description": "Skyline Cabs ensures that your drop-off to Mumbai Airport is as smooth as possible. Whether you’re traveling to Terminal 1, 2, or 3, we provide timely and efficient drop-off services, so you never miss your flight."
    },
    {
      "name": "Pune to Mumbai Airport Drop Taxi",
      "description": "Skyline Cabs offers a reliable and efficient drop taxi service from Pune to Mumbai Airport. We ensure timely arrivals at all terminals and provide a seamless travel experience, allowing you to relax and enjoy your trip."
    },
    {
      "name": "Pune to Mumbai Airport Terminal 2",
      "description": "Need a ride to Mumbai Airport Terminal 2? Skyline Cabs provides reliable airport transfers to all terminals, including Terminal 2. Our professional drivers know the best routes to ensure you arrive on time."
    },
    {
      "name": "Pune to Mumbai Airport Terminal 1",
      "description": "Skyline Cabs offers comfortable and timely rides to Mumbai Airport Terminal 1 from Pune. Our drivers are familiar with the route and ensure a smooth ride, so you can focus on your journey ahead."
    },
    {
      "name": "Pune to Mumbai Airport Terminal 3",
      "description": "Traveling to Mumbai Airport Terminal 3? Skyline Cabs ensures a seamless and comfortable ride from Pune to your terminal, with punctual and friendly drivers to make your trip stress-free."
    },
    {
      "name": "Pune to Mumbai Skyline Cabs",
      "description": "Skyline Cabs offers premium taxi services for those traveling between Pune and Mumbai. With a wide range of vehicles and professional drivers, we guarantee a comfortable and reliable journey every time."
    },
    {
      "name": "Mumbai Airport Taxi from Pune",
      "description": "Skyline Cabs offers a convenient taxi service from Pune to Mumbai Airport. Whether you're catching a flight or arriving from a long journey, we ensure that your airport transfer is as comfortable and timely as possible."
    }
  ],

  "tableData": [
    ["Pune to Mumbai Airport Cab", "-Pune to Mumbai Taxi Service"],
    ["Pune to Mumbai Airport Cab Fare", "-Pune Mumbai Airport Car Hire"],
    ["Pune to Mumbai Airport", "-Pune to Mumbai Airport Cab Booking"],
    ["Pune to Mumbai Airport Taxi Fare", "-Pune to Mumbai Airport Drop"],
    ["Mumbai to Pune Innova Crysta Cab Booking", "-Pune to Mumbai Cab Round Trip"],
    ["Pune to Mumbai Ertiga Cab", "-Pune to Mumbai Innova Cab"],
    ["Pune to Mumbai Airport Cab Service", "-Pune to Mumbai Airport Cab Fare"],
    ["Pune to Mumbai Airport Taxi", "-Pune to Mumbai Airport Innova"],
    ["Pune to Mumbai Airport Drop Cab", "-Pune to Mumbai Airport Drop Taxi"],
    ["Pune to Mumbai Airport Terminal 2", "-Pune to Mumbai Airport Terminal 1"],
    ["Pune to Mumbai Airport Terminal 3", "-Pune to Mumbai Skyline Cabs"]
  ],

  whychoose: [
    {
        "WhyChooseheading": "Reliable Pune to Mumbai Airport Cab Service",
        "WhyChoosedescription": "Skyline Cabs ensures you reach the Mumbai Airport on time, every time. Our punctual service is ideal for early morning flights, late-night arrivals, or business travel."
    },
    {
        "WhyChooseheading": "Comfortable Airport Transfers",
        "WhyChoosedescription": "Travel in comfort with our spacious and well-maintained vehicles. Skyline Cabs offers a smooth and relaxing ride for your Pune to Mumbai Airport transfer, with ample space for luggage."
    },
    {
        "WhyChooseheading": "Trained and Professional Drivers",
        "WhyChoosedescription": "Our drivers are experienced, courteous, and familiar with the best routes to Mumbai Airport. They ensure a safe, smooth, and stress-free airport transfer experience."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Surprises",
        "WhyChoosedescription": "Skyline Cabs offers fixed and competitive rates for Pune to Mumbai Airport cab services. No hidden charges—just honest, upfront pricing."
    },
    {
        "WhyChooseheading": "24/7 Airport Cab Availability",
        "WhyChoosedescription": "Flight at odd hours? No problem. Skyline Cabs operates round-the-clock, so you can book your Pune to Mumbai Airport cab at any time of the day or night."
    },
    {
        "WhyChooseheading": "Well-Maintained Fleet for Long-Distance Travel",
        "WhyChoosedescription": "Our vehicles are regularly serviced and thoroughly cleaned, ensuring comfort and reliability for your long-distance airport journey."
    },
    {
        "WhyChooseheading": "Easy Online Booking",
        "WhyChoosedescription": "Book your Pune to Mumbai Airport cab easily through our website, mobile app, or by phone. Get instant confirmations and travel without hassle."
    },
    {
        "WhyChooseheading": "Safe and Secure Airport Transfers",
        "WhyChoosedescription": "With GPS-enabled cabs, verified drivers, and 24/7 customer support, Skyline Cabs ensures a safe and secure journey to Mumbai Airport from Pune."
    }
]



    }


    const faqData = [
        {
            id: 1,
            question: 'How can I book a Pune to Mumbai Airport cab with Skyline Cabs?',
            answer:
                'Booking a cab with Skyline Cabs is easy. Simply visit our website or use our mobile app to make a reservation, or call our customer support team for assistance.',
        },
        {
            id: 2,
            question: 'Are Skyline Cabs drivers experienced with airport pickups and drop-offs?',
            answer:
                'Yes, our drivers are well-versed in airport procedures and ensure timely pickups and drop-offs. They’re familiar with the routes and parking areas at Mumbai Airport to make your journey smooth.',
        },
        {
            id: 3,
            question: 'What vehicles does Skyline Cabs offer for the Pune to Mumbai Airport journey?',
            answer:
                'Skyline Cabs provides a variety of vehicle options for your convenience, including compact cars, sedans, SUVs, and luxury vehicles, all equipped with air conditioning and ample luggage space.',
        },
        {
            id: 4,
            question: 'What payment methods are accepted for my Pune to Mumbai Airport cab ride?',
            answer:
                'We accept multiple payment options, including cash, credit/debit cards, UPI, and secure online payments via our app for your convenience.',
        },
        {
            id: 5,
            question: 'Can I book a one-way trip to Mumbai Airport from Pune?',
            answer:
                'Yes, we offer one-way trips from Pune to Mumbai Airport. Simply select the "One-Way" option while booking, and you’ll receive confirmation of your ride.',
        },
        {
            id: 6,
            question: 'Are there any additional charges for waiting or detours?',
            answer:
                'We maintain transparent pricing at Skyline Cabs. Any additional charges for waiting time or detours will be communicated to you beforehand, with no hidden fees.',
        },
        {
            id: 7,
            question: 'Is there any special service for late-night or early-morning airport rides?',
            answer:
                'Yes, we provide round-the-clock service for airport transfers, even during late-night or early-morning hours. Our drivers are available at any time to ensure your timely arrival at the airport.',
        },
        {
            id: 8,
            question: 'What is the luggage allowance for a Pune to Mumbai Airport ride?',
            answer:
                'Our vehicles can accommodate standard luggage. If you have excess luggage, feel free to let us know when booking so we can arrange a more suitable vehicle for your needs.',
        },
        {
            id: 9,
            question: 'Does Skyline Cabs offer corporate airport transfers?',
            answer:
                'Yes, we provide corporate airport transfer services. If you need regular business trips to and from the airport, we offer flexible packages and priority bookings.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for my Pune to Mumbai Airport travel?',
            answer:
                'Skyline Cabs is known for its punctuality, cleanliness, and professional drivers. We ensure a stress-free and comfortable ride to and from the airport, making your journey hassle-free and timely.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Vikram Soni",
            rating: 5,
            review: "I needed a cab to catch an early morning flight to Mumbai, and Skyline Cabs did not disappoint. The driver arrived on time, and the ride was smooth. I reached the airport in no time. Highly recommend their airport transfer service!"
        },
        {
            name: "Miss. Sneha Desai",
            rating: 4,
            review: "I booked a ride to Mumbai Airport for my evening flight, and the service was excellent. The car was clean, and the driver was courteous. However, I would have appreciated more information on the estimated time of arrival during the booking process."
        },
    ];
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Airport Cab",
  "image": "https://skylinecabs.com/assets/images/pune-to-mumbai-airport-cab.jpg",
  "description": "Book Pune to Mumbai Airport cab with Skyline Cabs for on-time pickups, professional drivers, and clean AC cabs. 24/7 airport drop service at competitive fares.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7593"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1450",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/pune-to-mumbai-airport-cab"
  }
};



      


    return (
        <div>
   
  <Helmet>
  <title>Pune to Mumbai Airport Cab | 24x7 Drop Service | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai Airport cab with Skyline Cabs for on-time pickups, professional drivers, and clean AC cabs. 24/7 airport drop service at competitive fares." 
  />
  <meta 
    name="keywords" 
    content="Pune to Mumbai Airport Cab, Pune to Mumbai Airport Drop Taxi, 24/7 Cab Pune to Mumbai Airport, One-Way Cab Pune to Mumbai Airport, Sedan Cab Pune to Airport, SUV Taxi Pune to Mumbai Airport, On-Time Airport Cab Pune, AC Cab Pune to Mumbai Airport, Affordable Airport Transfer Pune to Mumbai, Pune Airport Drop Cabs, Skyline Cabs Airport Service, Verified Airport Taxi Pune to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/2.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaiairportcab;